// Auth.js
import AuthHelperMethods from "./AuthHelperMethods";
const Auth = new AuthHelperMethods();
export default Auth;
